export const isRealId = (id) => {
  return id && id.length > 10; 
};